import React from "react";
import { navigate } from "gatsby";
import * as styles from "./parts.module.scss";

export const BackButton = () => {
  return (
    <div className={styles.backButton}>
      <button
        onClick={(e) => {
          e.stopPropagation();
          navigate(-1);
        }}
      >
        <div>
          <img src="/back.svg" />
          <div>Retour</div>
        </div>
      </button>
    </div>
  );
};
